import { useEffect, useState } from 'react';
import { fetchRole } from './useIsAdmin';

export const ADMIN_UNLOCK_KEY = 'vaad_admin_unlocked_v1';

const readFlag = () => {
  try { return localStorage.getItem(ADMIN_UNLOCK_KEY) === 'yes'; }
  catch { return false; }
};

/**
 * Is the admin toolset available on THIS device?
 *
 * Jun-2026 (user: "on mobile i cant select folders or photos or anything
 * to archive them"): the archive affordances were gated purely on the
 * `vaad_admin_unlocked_v1` localStorage flag, set by the More-page
 * passcode modal. localStorage is per-browser — and the installed iOS
 * PWA has its own storage — so an admin who unlocked on the desktop saw
 * NO archive buttons on the phone. A signed-in admin now counts as
 * unlocked everywhere, and we persist the flag for the rest of the app.
 */
export function useAdminUnlockedState() {
  const [unlocked, setUnlocked] = useState(readFlag);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const sync = () => setUnlocked(readFlag());
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);

  useEffect(() => {
    let alive = true;
    fetchRole().then((r) => { if (alive) setRole(r || 'anonymous'); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (role !== 'admin' || unlocked) return;
    try { localStorage.setItem(ADMIN_UNLOCK_KEY, 'yes'); } catch { /* ignore */ }
    setUnlocked(true);
  }, [role, unlocked]);

  return { unlocked: unlocked || role === 'admin', loading: role === null && !unlocked };
}

export default function useAdminUnlocked() {
  return useAdminUnlockedState().unlocked;
}
